<template>
  <el-popover
    class="confirmation-dialog"
    v-model:visible="isPopoverVisible"
    trigger="manual"
    persistent
  >
    <template #default>
      <div class="confirmation-dialog__popover" @click.stop>
        <div class="confirmation-dialog__text">
          {{ content }}
        </div>

        <div class="confirmation-dialog__buttons">
          <el-button
            :type="cancelButtonType || 'text'"
            @click.stop="handleCancel"
          >
            {{ cancelButtonText || 'No' }}
          </el-button>
          <el-button
            :type="confirmButtonType || 'primary'"
            @click.stop="handleConfirm"
          >
            {{ confirmButtonText || 'Yes' }}
          </el-button>
        </div>
      </div>
    </template>

    <template #reference>
      <div @click="togglePopover">
        <slot></slot>
      </div>
    </template>
  </el-popover>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'ConfirmationDialog',
  props: {
    content: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      required: false,
    },
    cancelButtonText: {
      type: String,
      required: false,
    },
    confirmButtonType: {
      type: String,
      required: false,
    },
    cancelButtonType: {
      type: String,
      required: false,
    },
  },
  setup(_, { emit }) {
    const isPopoverVisible = ref(false);

    const togglePopover = (event) => {
      event.stopPropagation();
      isPopoverVisible.value = !isPopoverVisible.value;
    };

    const handleConfirm = (event) => {
      event.stopPropagation();
      isPopoverVisible.value = false;
      emit('on-confirm');
    };

    const handleCancel = (event) => {
      event.stopPropagation();
      isPopoverVisible.value = false;
      emit('on-cancel');
    };

    return {
      isPopoverVisible,
      handleConfirm,
      handleCancel,
      togglePopover,
    };
  },
};
</script>

<style lang="scss">
@import '@/styles/shared/_globals.scss';

.confirmation-dialog {
  display: inline-block;

  &__text {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 10px;
  }
  &__buttons {
    text-align: right;
  }
}
</style>
